import { dockDoorStatusColor } from "../../../util/helper/helperFunctions";

const DockDoorTopView = ({ loading, palletsInDockDoor }) => {
  const renderPallets = (value) => {
    const [firstPallet, secondPallet] = value;
    const { sku, palletStatus, shipmentId } = firstPallet;
    const backgroundColor = dockDoorStatusColor(palletStatus);

    if (secondPallet) {
      return (
        <div className="dock dock-popup-big">
          {value.map(({ palletStatus, sku }, index) => (
            <div
              key={index}
              style={{ backgroundColor }}
              className={`dock-popup dock-popup-big-complex-${
                !index ? "left" : "right"
              }`}
            >
              <h4>
                {sku}
                <br />
                {palletStatus}
              </h4>
            </div>
          ))}
        </div>
      );
    } else if (!shipmentId) {
      return "No Pallets";
    } else {
      return (
        <div
          style={{ backgroundColor }}
          className="dock-popup dock-popup-small"
        >
          <h4>
            {sku}
            <br />
            {palletStatus}
          </h4>
        </div>
      );
    }
  };

  return (
    <div className="dock-door-popup">
      <div className="dock-door-popup-container">
        <div className="dock-popup-top-section">
          {loading
            ? "Loading..."
            : Object.values(palletsInDockDoor).length &&
              Number(Object.values(palletsInDockDoor)[0][0].dock.split(".")[1])}
        </div>
        <div className="dock-popup-bottom-section">
          {loading ? (
            <div className="rm-loader">
              <h4>Loading...</h4>
              <div className="spinner"></div>
            </div>
          ) : (
            Object.values(palletsInDockDoor).map((value) =>
              renderPallets(value)
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default DockDoorTopView;
